<template>
  <v-dialog class="md-4" id="edit-profile" max-width="700px" persistent v-model="popup">
    <v-form>
    <v-card>      
      <v-card-title class="white" dark>
        <span >Edit Profile</span>
        <v-spacer></v-spacer>
          <v-btn small  fab depressed class="mr-2 white--text"  color="red" sole @click="close"> <v-icon>mdi-close</v-icon></v-btn>
        <span>
          <v-btn
            fab
            small
            depressed
            color="green" 
            :loading="loading"
            :disabled="loading"
            class="mr-2 white--text"
            sole
            @click="update"
          >
          <v-icon>mdi-check</v-icon>
          </v-btn>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>

        <v-row>
          <v-col cols="6">
            <v-label>Display Name</v-label>
            <InputField
              v-model="form.display_name"
              :setectVale="form.display_name"
              @changeInput="form.display_name = $event"
            />
          </v-col>

          <v-col cols="6">
            <v-label>Full Name</v-label>
            <InputField
              v-model="form.full_name"
              :setectVale="form.full_name"
              @changeInput="form.full_name = $event"
            />
          </v-col>

          <v-col cols="6">
            <v-label>Birthday</v-label>
            <DateOfBirth
              v-model="form.birth_day"
              :setectVale="form.birth_day"
              @changeInput="form.birth_day = $event"
            />           
          </v-col>          

          <v-col cols="6">
            <v-label>Gender</v-label>    
            <v-radio-group v-model="form.gender" row>
                <v-radio :label="item"  v-for="(item,index) in genders" :key="index" :value="item"></v-radio>
            </v-radio-group>    
          </v-col>     

          <v-col cols="6">
            <v-label>Suffix</v-label>
            <InputField
              v-model="form.suffix"
              :setectVale="form.suffix"
              @changeInput="form.suffix = $event"
            />
          </v-col>

           <v-col cols="6">
            <v-label>Title</v-label>
            <InputField
              v-model="form.title"
              :setectVale="form.title"
              @changeInput="form.title = $event"             
            />
          </v-col>    
          <v-col cols="6">
            <v-label>Spouse</v-label>
            <InputField
              v-model="form.spouse"
              :setectVale="form.spouse"
              @changeInput="form.spouse = $event"             
            />
          </v-col> 
          <v-col cols="6">
            <v-label>Mobile (71xxxx)</v-label>
            <InputField
              v-model="form.mobile"
              :setectVale="form.mobile"
              @changeInput="form.mobile = $event"             
            />
          </v-col>        
          <v-col cols="6">
            <v-label>Email</v-label>
            <InputField
              v-model="form.email"
              :setectVale="form.email"
              @changeInput="form.email = $event"             
            />
          </v-col>          
           <v-col cols="12">
            <v-label>Profile Image (200px X 200px)</v-label>    
             <FileUpload @changeFile="changeFile"  :type='"image/*"' />
          </v-col>
         
        </v-row>
      </v-container>      
    </v-card>
    </v-form>
  </v-dialog>
</template>


<script>
import Alert from "@/components/shared/Alert";
import DateOfBirth from "@/components/shared/DateOfBirth";
import InputField from "@/components/shared/InputField";
import FileUpload from "@/components/shared/FileUpload";
import { MemberService } from "@/services/member-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "AddClassroom",
  props: ["popup", "member"],
  components: {Alert, InputField, DateOfBirth, FileUpload},

  data: () => ({
    form: {
      display_name: null,
      full_name: null,
      title: null,
      phone: "",
      mobile: "",
      email: "",
      spouse: "",     
      birth_day: "",
      gender: "",    
      image: "",    
      suffix: "",        
    },
    emaildisable: false,
    mobiledisable: false,
    errors: null,
    loading: false,
    genders: ["Male", "Female", "Preferred not to say"],  
    titleList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Prof"],
  }),

   watch: {
    member: function() {
      let self = this;
      self.form.display_name = this.member.display_name;
      self.form.full_name = this.member.full_name;
      self.form.mobile = this.member.mobile;   
      self.form.birth_day = this.member.birth_day;
      self.form.gender = this.member.gender;
      self.form.email = this.member.email;
      self.form.spouse = this.member.spouse;    
      self.form.suffix = this.member.suffix;
      self.form.title = this.member.title;      
      self.uuid = this.member.uuid;
    }   
  },

  mounted() {
   
    this.onDismissed();
  },

  methods: {
    update() {      
      this.loading = true;   
       this.errors = null;  
       let fd = new FormData();
       fd.append('image', null);   
       if(this.form.profile_image){
           fd.append('image', this.form.profile_image);   
       }
     
      fd.append('display_name', this.form.display_name);        
      fd.append('full_name', this.form.full_name);    
      fd.append('birth_day', this.form.birth_day ==null ? '' : this.form.birth_day);    
      fd.append('gender', this.form.gender);    
      fd.append('spouse', this.form.spouse);        
      fd.append('suffix', this.form.suffix);    
      fd.append('title', this.form.title);   
      fd.append('mobile', this.form.mobile);   
      fd.append('email', this.form.email);   
     
      let data = fd;       
       MemberService.update(this.member.uuid, data) 
        .then(response => {
          this.loading = false;
          if (response.data.data) {            
            this.reset();
            this.$emit("successEdit", true);  
          }
        })
        .catch(error => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    
    },

    onDismissed() {
       this.errors= null;
    },
    
    changeFile(event) {
      this.form.profile_image = event;
    },

    close() {
      this.reset();
      this.onDismissed();
      this.$emit("modalStatus", !this.popup);
    },
    reset() {      
      this.form.profile_image = null;
    
    },

  
  }
};
</script>

